import CryptoJS from "crypto-js";
import AsyncValidator from "async-validator";

/* 日期转化 */
export function formatDate(NewDtime) {
  let datetime = new Date(NewDtime);
  let year = datetime.getFullYear();
  let month = (datetime.getMonth() + 1).toString(); //js从0开始取
  let date = datetime.getDate().toString();
  let hour = datetime.getHours().toString();
  let minutes = datetime.getMinutes().toString();
  let second = datetime.getSeconds().toString();

  if (parseInt(month) < 10) {
    month = "0" + month;
  }
  if (parseInt(date) < 10) {
    date = "0" + date;
  }
  if (parseInt(hour) < 10) {
    hour = "0" + hour;
  }
  if (parseInt(minutes) < 10) {
    minutes = "0" + minutes;
  }
  if (parseInt(second) < 10) {
    second = "0" + second;
  }
  let time = year + "-" + month + "-" + date + " " + hour + ":" + minutes + ":" + second; //2009-06-12 17:18:05
  return time;
}
//将base64转换为blob
export function dataURLtoFile(dataURI, type) {
  let binary = atob(dataURI.split(",")[1]);
  let array = [];
  for (let i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i));
  }
  return new Blob([new Uint8Array(array)], { type: type });
}
// 格式化时间
export const formatDateReg = (d, fmt) => {
  let o = {
    "M+": d.getMonth() + 1, //月份
    "d+": d.getDate(), //日
    "h+": d.getHours(), //小时
    "m+": d.getMinutes(), //分
    "s+": d.getSeconds(), //秒
    "q+": Math.floor((d.getMonth() + 3) / 3), //季度
    S: d.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (d.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (let k in o) if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
  return fmt;
};
// 加密方法
export const encryptByDES = (message, key) => {
  console.log("key", key);
  let keyHex = CryptoJS.enc.Utf8.parse(key);
  let encrypted = CryptoJS.DES.encrypt(message, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
};

export function deepCopyRef(obj) {
  let _obj = {}; //标记一个对象，使其永远不会转换为 proxy。返回对象本身。
  return Object.assign(_obj, obj);
}

function getCookie(name) {
  let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  let arr = document.cookie.match(reg);
  if (arr) return unescape(arr[2]);
  else return null;
}

function DateStrKey() {
  let date = new Date();
  let y = date.getFullYear().toString();
  let m = (date.getMonth() + 1).toString();
  let d = date.getDate().toString();

  if (parseInt(m) < 10) {
    m = "0" + m;
  }
  if (parseInt(d) < 10) {
    d = "0" + d;
  }
  return `${y}-${m}-${d}`;
}

// 加密
export const encryptDES = (message, desKey) => {
  const key = desKey || `${getCookie("JSESSIONID")}-${DateStrKey()}`;
  const keyHex = CryptoJS.enc.Utf8.parse(key);
  if (message) {
    let encrypt = CryptoJS.DES.encrypt(message, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypt.toString();
  } else {
    return "";
  }
};

// 解密
export const decryptDES = (ciphertext, desKey) => {
  const key = desKey || `${getCookie("JSESSIONID")}-${DateStrKey()}`;
  const keyHex = CryptoJS.enc.Utf8.parse(key);
  if (ciphertext) {
    let decrypted = CryptoJS.DES.decrypt(ciphertext, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  } else {
    return "";
  }
};

/**
 * @author 伟健 / 张
 * @name 根据key赋值
 * @param
 * @return original
 */
const hasOwnProperty = Object.prototype.hasOwnProperty;
export const setval = (original, _from) => {
  for (let key in original) {
    if (hasOwnProperty.call(_from, key)) {
      original[key] = _from[key];
    }
  }
  return original;
};

/**
 * @author 伟健 / 张
 * @name 清空对象值
 * @param
 * @return
 */
export const reset = (original,defaultVal) => {
  let len = Object.keys(original).length;
  for (let key in original) {
    if(len){
      if(hasOwnProperty.call(defaultVal, key)){
        original[key] = defaultVal[key];
      }else{
        original[key] = "";
      }
    }else{
      original[key] = "";
    }
  }
  return original;
};

export let throttle = function (action, delay) {
  let timeout = null;
  let lastRun = 0;
  return function () {
    if (timeout) {
      return;
    }
    let elapsed = Date.now() - lastRun;
    let context = this;
    let args = arguments;
    let runCallback = function () {
      lastRun = Date.now();
      timeout = false;
      action.apply(context, args);
    };
    if (elapsed >= delay) {
      runCallback();
    } else {
      timeout = setTimeout(runCallback, delay);
    }
  };
};

export let requiredVal = function () {
  let arg = [...arguments];
  return !arg.some((el) => {
    return el === "" || el === undefined || el === null || el.length == 0;
  });
};

export let dateFormat = (date, fmt) => {
  if (!date) return "";

  let o = {
    "M+": date.getMonth() + 1, // 月份
    "d+": date.getDate(), // 日
    "h+": date.getHours(), // 小时
    "m+": date.getMinutes(), // 分
    "s+": date.getSeconds(), // 秒
    "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return fmt;
};
/**
 * @author 伟健 / 张
 * @name 合并对象
 * @param
 * @return
 */
export const extend = (vm, to, _from) => {
  for (let key in _from) {
    if (to[key] == undefined || to[key] == null || to[key] === "") {
      vm.$set(to, key, _from[key]);
    }
  }
  return to;
};

export const getPosition = (obj) => {
  var el = obj.getBoundingClientRect();
  var top = el.top - document.documentElement.clientTop + document.documentElement.scrollTop, //document.documentElement.clientTop 在IE67中始终为2，其他高级点的浏览器为0
    bottom = el.bottom,
    left = el.left - document.documentElement.clientLeft + document.documentElement.scrollLeft, //document.documentElement.clientLeft 在IE67中始终为2，其他高级点的浏览器为0
    right = el.right,
    width = el.width || right - left, //IE67不存在width 使用right - left获得
    height = el.height || bottom - top;

  return {
    y: top,
    right: right,
    bottom: bottom,
    x: left,
    width: width,
    height: height,
  };
};

// 获取滚动条距离
export const getScroll = (direction, el) => {
  if (el) {
    return el[direction] || el[direction];
  }
  return document.body[direction] || document.documentElement[direction];
};

export const classNameToArray = (cls = "") => cls.split(" ").filter((item) => !!item.trim());

export const addClass = (el, cls) => {
  if (!el || !cls.trim()) return;
  el.classList.add(...classNameToArray(cls));
};

export const removeClass = (el, cls) => {
  if (!el || !cls.trim()) return;
  el.classList.remove(...classNameToArray(cls));
};

export const remove = (arr, item) => {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1);
    }
  }
};

export const browserType = () => {
  return window.navigator.userAgent;
};
export let isIE = function () {
  if (!!window.ActiveXObject || "ActiveXObject" in window) return true;
  else return false;
};

export let openUrl = function (url) {
  if (!url) return;
  let reg = /#[\/\w]+\?/;

  if (url.match(reg)) {
    if (url.match(reg)[0] == window.location.href.match(reg) && window.location.href.match(reg)[0]) {
      return;
    }
  }

  if (isIE()) {
    try {
        if (url.indexOf("#") > -1) {
          url = url.split("#")[1];
          let path = url.split("?")[0];
          this.$router.push({ path, query: rulTojson(url) });
        }
    } catch (e) {
      console.log(e);
      location.assign(encodeURIComponent(url));
      window.location.href = url;
    }
  } else {
    window.location.href = url;
  }
};
export const isString = (val) => typeof val === "string";
 
/**
 * @author 伟健 / 张
 * @name  传入对象，键，返回对应值
 * @param obj keys
 * @return obj[]
 */
export const keysRetrievalObj = (obj, keys) => {
  if (obj && keys) {
    return [];
  }
};

/* 
递归对象,并获取对象指定 键的值
*/

export const recursiveSearch = (obj, key, key1) => {
  let res = [];
  function main(obj, key, key1) {
    if (obj[key1]) {
      res.push(obj[key1]);
    }
    for (let i = 0; i < obj.length; i++) {
      if (obj[i][key]) {
        main(obj[i][key], key, key1);
      } else {
        main(obj[i], key, key1);
      }
    }
  }
  main(obj, key, key1);
  return res;
};

export let base64toFile = (dataurl, filename = "file") => {
  let arr = dataurl.split(",");
  let mime = arr[0].match(/:(.*?);/)[1];
  let suffix = mime.split("/")[1];
  let bstr = atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  let File = window.File;
  try {
    new File([], "");
  } catch (e) {
    console.log(e);
    File = class File extends Blob {
      constructor(chunks, filename, opts = {}) {
        super(chunks, opts);
        this.lastModifiedDate = new Date();
        this.lastModified = +this.lastModifiedDate;
        this.name = filename;
      }
    };
  }
  return new File([u8arr], `${filename}.${suffix}`, {
    type: mime,
  });
};
/**
 * @author 伟健 / 张
 * @name 检查 formData 参数
 */
export let checkFormData = (formData, rules, callback) => {
  if (!rules || !formData) return;

  let valid = true;
  let validateMessage = "";
  Object.keys(formData).forEach((key) => {
    let descriptor = {};
    if (!rules[key] || !valid) return;
    descriptor[key] = rules[key];
    let validator = new AsyncValidator(descriptor);
    let model = {};
    model[key] = formData[key];
    // console.log(model[key]);
    validator.validate(model, { firstFields: true }, (errors) => {
      let validateState = !errors ? "success" : "error";
      validateMessage = errors ? errors[0].message : "";
      if (validateState == "error") {
        valid = false;
      }
    });
  });
  callback(valid, validateMessage);
};
export const copyText = (value, fn) => {
  if (!value) {
    return;
  }
  var textArea = document.createElement("textarea");
  textArea.style.background = "transparent";
  textArea.value = value;
  document.body.appendChild(textArea);
  textArea.select();
  try {
    document.execCommand("copy");
    fn && fn();
    // this.$message.success({
    //   message: '复制成功',
    // });
  } catch (err) {
    console.log(err);
    console.log("Oops, unable to copy");
  }
  document.body.removeChild(textArea);
};

export let setCopyright = function (value) {
  this.guaranteeChannelHtmlPage = value;
  document.title = value.htmlTitle || "保函申请";
  var favicon = document.querySelector('link[rel="icon"]');
  if (favicon !== null) {
    favicon.href = value.htmlIcon;
  } else {
    favicon = document.createElement("link");
    favicon.rel = "shortcut icon";
    favicon.href = value.htmlIcon;
    document.head.appendChild(favicon);
  }
  Mirror.emit(`setCopyright`, value);
};

export let rulTojson = function (url) {
  let obj = {};
  let index = url.indexOf("?");
  if (index > -1) {
    let strs = url.split("?")[1].split("&");
    for (let i = 0; i < strs.length; i++) {
      obj[strs[i].split("=")[0]] = strs[i].split("=")[1] || "";
    }
  }
  return obj;
};

// 获取地址栏参数
export let getUrlQuery = function () {
  if (!window.location.href.split("?")[1]) {
    return false
  }
  let urlStr = window.location.href.split("?")[1];
  let queryStrList = urlStr.split("&");
  let queryObj = {};
  for (let i = 0; i < queryStrList.length; i++) {
    let queryStr = queryStrList[i];
    let queryStrArr = queryStr.split("=");
    queryObj[queryStrArr[0]] = queryStrArr[1];
  }
  console.log(queryObj)
  return queryObj;
};
export let getSignTaction = function () {
  // let signApis = {

  //   GongcTenderbidInsure: "customer/seal/", //工程投标保函
  //   GongcTenderbid: "customer/seal/", //工程投标保函
  //   GongcSafeLiability: "customer/seal/", // 安责险
  //   PurchaseTenderbid: "customer/seal/", //政采投标保函
  //   CourtLowsuit: "customer/seal/", //法院诉讼
  //   PurchaseContract: "customer/seal/", //政采合同履约
  //   GongcContract: "customer/seal/", //工程合同履约
  //   GongcNongmg: "customer/seal/", ///农民工工资保函
  //   GongcQuality: "customer/seal/", //工程质量保函
  //   CustomsInsure: "customer/seal/external/",//海关投保
  //   CustomsCancel: 'customer/seal/external/',//海关退保
  // }
  let newProject = [
    'CustomsInsure',
    'CustomsCancel',
    'GongcOwnerAdvancePaymentInsure',
    'GongcOwnerAdvancePaymentCancel',
    'PurchaseOwnerAdvancePaymentInsure',
    'PurchaseOwnerAdvancePaymentCancel',
    'OwnerEnsurePaymentInsure',
    'OwnerEnsurePaymentCancel',
  ]
  let query = getUrlQuery()

  if (query && query.taction && newProject.indexOf(query.taction) > -1) {
    return "customer/seal/external/";
  } else {
    return "customer/seal/"
  }
};
